import { __extends } from "tslib";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { DropDownList } from "../DropDownList";
import { ITranslations } from "../../models/translations";
import { IAsyncState } from "../../state/action";
import { ILoadNodesPayloadRequest } from "../../state/actions";
import { ButtonWithIcon } from "../ButtonWithIcon";
var DataModelDropDown = (function (_super) {
    __extends(DataModelDropDown, _super);
    function DataModelDropDown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderScopeDesktopTitle = function () {
            var _a = _this.props, showScopesDropdown = _a.showScopesDropdown, t = _a.t;
            if (!showScopesDropdown) {
                return null;
            }
            return (React.createElement("div", { className: "col-md-4 col-sm-5" },
                React.createElement("div", { className: "rb-title-dark rb-title-small" }, t.scopesDropdownTitle)));
        };
        _this.renderScopeDropDown = function () {
            var _a = _this.props, scopeNames = _a.scopeNames, selectedScope = _a.selectedScope, onScopeChanged = _a.onScopeChanged, showScopesDropdown = _a.showScopesDropdown, t = _a.t;
            if (!showScopesDropdown) {
                return null;
            }
            var scopeNamesData = scopeNames && scopeNames.data;
            var list = scopeNamesData && new Map(scopeNamesData.map(function (d) { return [d, d]; }));
            return (React.createElement("div", { className: "col-md-4 col-sm-5" },
                React.createElement("div", { className: "rb-title-dark rb-title-small visible-xs" }, t.scopesDropdownTitle),
                React.createElement(DropDownList, { list: list, defaultLabel: t.scopesPlaceholder, selected: selectedScope, itemSelectedCallback: onScopeChanged })));
        };
        _this.renderDataModelDesktopTitle = function () {
            var _a = _this.props, showDataModelsDropdown = _a.showDataModelsDropdown, t = _a.t;
            if (!showDataModelsDropdown) {
                return null;
            }
            return (React.createElement("div", { className: "col-md-4 col-sm-5" },
                React.createElement("div", { className: "rb-title-dark rb-title-small" }, t.dataModelsDropdownTitle)));
        };
        _this.renderDataModelDropDown = function () {
            var _a = _this.props, dataModelNames = _a.dataModelNames, selectedDataModel = _a.selectedDataModel, showDataModelsDropdown = _a.showDataModelsDropdown, t = _a.t;
            if (!showDataModelsDropdown) {
                return null;
            }
            var dataModelNamesData = dataModelNames && dataModelNames.data;
            var list = dataModelNamesData && new Map(dataModelNamesData.map(function (d) { return [d, d]; }));
            return (React.createElement("div", { className: "col-md-4 col-sm-5" },
                React.createElement("div", { className: "rb-title-dark rb-title-small visible-xs" }, t.dataModelsDropdownTitle),
                React.createElement(DropDownList, { list: list, defaultLabel: t.dataModelsPlaceholder, selected: selectedDataModel, itemSelectedCallback: _this.onDataModelChanged })));
        };
        _this.showSaveButton = function () {
            var request = _this.props.request;
            return (request &&
                ((request.metrics && request.metrics.length > 0) ||
                    (request.dimensions && request.dimensions.length > 0)));
        };
        _this.renderSaveButton = function () {
            var _a = _this.props, t = _a.t, onSaveReportRequest = _a.onSaveReportRequest, request = _a.request;
            if (!_this.showSaveButton() || !onSaveReportRequest)
                return;
            return (React.createElement("div", { style: { width: "100%" } },
                React.createElement(ButtonWithIcon, { icon: faSave, styleClasses: "rb-btn-small rb-btn-crimson", style: {
                        float: "right",
                        marginRight: 13,
                    }, onClick: function () { return onSaveReportRequest(request); }, title: t.saveButtonText })));
        };
        _this.onDataModelChanged = function (selectedDataModel) {
            var onDataModelChanged = _this.props.onDataModelChanged;
            onDataModelChanged({ selectedDataModel: selectedDataModel });
        };
        return _this;
    }
    DataModelDropDown.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", { className: "row hidden-xs" },
                this.renderScopeDesktopTitle(),
                this.renderDataModelDesktopTitle()),
            React.createElement("div", { className: "row" },
                this.renderScopeDropDown(),
                this.renderDataModelDropDown(),
                this.renderSaveButton())));
    };
    DataModelDropDown.defaultProps = {
        showScopesDropdown: true,
        showDataModelsDropdown: true,
    };
    return DataModelDropDown;
}(React.Component));
export { DataModelDropDown };
